/**
 * Owns the display name for every source provider shown in Vault.
 *
 * Connector registration and stored provenance both use this catalog so a
 * provider cannot acquire different names on configuration and content pages.
 */
import type { ConnectorProvider } from '../connectors/types'

const CONNECTOR_PROVIDER_LABELS: Record<ConnectorProvider, string> = {
  box: 'Box',
  'kuali-research': 'Kuali Research',
  servicenow: 'ServiceNow',
  workday: 'Workday',
}

export const connectorProviderLabel = (provider: ConnectorProvider) => (
  CONNECTOR_PROVIDER_LABELS[provider]
)

const isConnectorProvider = (provider: string): provider is ConnectorProvider => (
  provider in CONNECTOR_PROVIDER_LABELS
)

export const sourceProviderLabel = (provider: string) => {
  if (isConnectorProvider(provider)) return connectorProviderLabel(provider)
  return provider === 'docreview' ? 'DocReview' : provider
}
